import hash from 'object-hash';
import type { OrderItemVm } from 'src/api/pidedirecto/types/OrderVm';

export function createOrderItemKey(orderItem: OrderItemVm): string {
    return hash(orderItem);
}
